module.exports = __webpack_public_path__ + "media/images/undraw/psc/data_trends-056c41b80063edf603a217cd51932738.png";